import React, { FC } from 'react';
import { StatusSelectProps } from './StatusSelectProps';
import { getOptionsFromTranslation } from '../../utils/utils';
import useTranslation from '../../hooks/useTranslation';
import { useFormContext } from 'react-hook-form';
import { returnDisplay } from '../../common/CustomSelect/utils';
import InputField from '@ingka/input-field';

const StatusSelect: FC<StatusSelectProps> = ({}) => {
  const t = useTranslation();
  const options = getOptionsFromTranslation(t, 'statuses');
  const { watch } = useFormContext();
  const value = watch('projectStatus');

  return (
    <InputField
      className={'read-only-input'}
      id={`status-select`}
      type={'text'}
      value={returnDisplay(value ?? 'RETURNED', options)}
      data-testid={'project-status'}
      readOnly
      label={t('projects.properties.projectStatus')}
    />
  );
};

export default StatusSelect;
